import { useCallback } from 'react';

import { analyticsLandingClickStorefront } from '@perpay-web/fintech/actions/ui/signup';
import { paychexOnboardingSegmentEventPayload } from '@perpay-web/fintech/components/composite/PaychexOnboarding/paychexUtils';
import SpendingLimitLanding from '@perpay-web/fintech/components/composite/SpendingLimitLanding/SpendingLimitLanding';
import { SIGNUP_FLOW_PAYROLL_PROVIDER_ONBOARDING } from '@perpay-web/fintech/constants/signupFlowTypes';
import { useAppDispatch, useAppSelector } from '@perpay-web/fintech/hooks';
import { getJWTData } from '@perpay-web/fintech/selectors/authentication';
import { getSignupFlowType } from '@perpay-web/fintech/selectors/ui/signup';
import { authentication } from '@perpay-web/fintech/settings/singletons';
import { getPartnerNameFromCode } from '@perpay-web/fintech/utils/partnerOnboardingUtils';
import { dollarToCents } from '@perpay-web/utils/numberUtils';

type SpendingLimitLandingContainerProps = {
    isSoloOptOut?: boolean;
};

const SpendingLimitLandingContainer = ({
    isSoloOptOut = false,
}: SpendingLimitLandingContainerProps) => {
    const dispatch = useAppDispatch();
    const { spendingLimit } = useAppSelector(getJWTData);
    const signupFlow = useAppSelector(getSignupFlowType);
    const partnerCode = authentication.getPartnerOnboardedCode();
    const partner = getPartnerNameFromCode(partnerCode);

    const isPaychexOnboardingFlow =
        signupFlow === SIGNUP_FLOW_PAYROLL_PROVIDER_ONBOARDING;

    const onLandingClickShop = useCallback(() => {
        const payload = {
            signupFlow,
            partner,
            ...(isPaychexOnboardingFlow &&
                paychexOnboardingSegmentEventPayload),
        };

        dispatch(analyticsLandingClickStorefront(payload));
    }, [dispatch, signupFlow, partner, isPaychexOnboardingFlow]);

    return (
        <SpendingLimitLanding
            spendingLimit={dollarToCents(spendingLimit)}
            onClickShop={onLandingClickShop}
            isSoloOptOut={isSoloOptOut}
        />
    );
};

export default SpendingLimitLandingContainer;
